import React, { useMemo, ReactElement } from 'react';
import VisibleCell from '../../../../components/visible-cell/visible-cell.component';
import Checkbox from '../../../../components/checkbox/checkbox.component';
import LongClickTableRow from '../../../../components/long-click-table-row/long-click-table-row.component';
import TableCellCheckbox from '../../../../components/table-cell-checkbox/table-cell-checkbox.component';
import DealTaskRowForm from '../deal-task-row-form/deal-task-row-form.component';
import { DEAL_TASK_STATUS_COMPLETED } from '../../../../constants/entity/deal-task-statuses';
import useScreenSmall from '../../../../hooks/use-screen-small';

const DealTaskRow: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const ID_PREFIX_CHECKBOX_EXPORT: string = 'checkbox-export';

  const {
    isActive,
    isSaving,
    isInlineSaving,
    isSaveDisabled,
    isSelected,
    isEditMode,
    isNewDeal,
    isSubTask,
    isExportMode,
    isSelectMode,
    isCustomizeMode,
    inputRefs,
    tableDealTaskListFields,
    dealTaskIndex,
    dealTaskItem,
    dealTaskParent,
    dealTaskGroup,
    dealTaskPlainList,
    dealTaskStatusList,
    dealTaskContactPersonList,
    accessLevelList,
    permissionList,
    onRowClick,
    onLongClick,
    onInlineSave,
    onInlineCancel,
    onDealTaskContactPersonSearch,
    onDealTaskContactPersonSearchClose,
  } = props;

  const isSmallScreen: boolean = useScreenSmall();

  const filteredDealTaskPlainList: DealTask[] = useMemo((): DealTask[] => (
    dealTaskPlainList && dealTaskPlainList.length
      ? dealTaskPlainList.filter((nestedDealTaskItem: DealTask): boolean => (
        nestedDealTaskItem.groupId === dealTaskGroup.id
      )) : []
  ), [dealTaskPlainList, dealTaskGroup]);

  return (
    (isEditMode || isNewDeal) && isActive ? (
      <DealTaskRowForm
        isActive={isActive}
        isSaving={isSaving}
        isSaveDisabled={isSaveDisabled}
        isInlineSaving={isInlineSaving}
        inputRefs={inputRefs}
        dealTaskIndex={dealTaskIndex}
        dealTaskData={dealTaskItem}
        dealTaskGroupData={dealTaskGroup}
        dealTaskStatusList={dealTaskStatusList}
        dealTaskList={filteredDealTaskPlainList}
        dealTaskContactPersonList={dealTaskContactPersonList}
        accessLevelList={accessLevelList}
        onInlineSave={onInlineSave}
        onInlineCancel={onInlineCancel}
        onDealTaskContactPersonSearch={onDealTaskContactPersonSearch}
        onDealTaskContactPersonSearchClose={onDealTaskContactPersonSearchClose}
      />
    ) : (
      <LongClickTableRow
        isActive={isSelected}
        isButton={!isCustomizeMode}
        isCompleted={dealTaskItem.status === DEAL_TASK_STATUS_COMPLETED}
        key={dealTaskItem.id}
        onClick={(event: React.MouseEvent<Element, MouseEvent>): void => {
          onRowClick(event, dealTaskItem, dealTaskGroup);
        }}
        onLongClick={(event: React.MouseEvent<Element, MouseEvent>): void => {
          onLongClick(event, dealTaskGroup.id, dealTaskItem.id);
        }}
      >
        {
          (isExportMode || isSelectMode) && (
            <TableCellCheckbox isSticky isStickyLeft>
              <Checkbox
                isChecked={isSelected}
                withNoPadding={!isSmallScreen}
                id={`${ID_PREFIX_CHECKBOX_EXPORT}-${dealTaskItem.id}`}
              />
            </TableCellCheckbox>
          )
        }
        {
          tableDealTaskListFields && !!tableDealTaskListFields.length
          && tableDealTaskListFields.map((tableField: TableField): ReactElement | boolean => (
            <VisibleCell
              isEditMode={isEditMode || isNewDeal}
              key={tableField.id}
              tableField={tableField}
              permissionList={permissionList}
            >
              {!!tableField.component && tableField.component(dealTaskItem, isSubTask, dealTaskParent, dealTaskGroup)}
            </VisibleCell>
          ))
        }
      </LongClickTableRow>
    )
  );
});

export default DealTaskRow;
